module.exports = __webpack_public_path__ + "static/media/icing-red.3840be27.png";